import { Country, Hotel, SearchOnlyHotelPackagesRequest } from '@appTypes/api.types';
import { DistrictsTreeItem } from '@appTypes/redefined-types';
import { RequestStateModel, StateFormModel } from '@core/store/store.models';
import { OnlyHotelPackageResults } from '../hotels.types';

export class HotelsSearchFormDataModel {
  locations = new RequestStateModel<DistrictsTreeItem[]>();
  hotels = new RequestStateModel<Hotel[]>();
  destinationCountries = new RequestStateModel<Country[]>();
  /** the country the search form opens with, as the API names it (Destination Module default); null = none */
  destinationDefaultCountry: string | null = null;
}

export class HotelsChildResultsModel {
  parentHotelCode!: string;
  results = new RequestStateModel<OnlyHotelPackageResults>();
}
export class HotelsStateModel {
  searchForm = new StateFormModel<SearchOnlyHotelPackagesRequest>();
  searchFormData = new HotelsSearchFormDataModel();
  /*  */
  searchResults = new RequestStateModel<OnlyHotelPackageResults>();
  childResults: HotelsChildResultsModel[] = [];
}
